import {
  FETCH_CUSTOMERMARKUP_LIST_START,
  FETCH_CUSTOMERMARKUP_LIST_SUCCESS,
  FETCH_CUSTOMERMARKUP_LIST_ERROR,
  EDIT_CUSTOMERMARKUP_RECORD,
  FUEL_COMPANY_PROVIDER_DD,
  FUEL_CUSTOMER_COMPANY_NAME_PROVIDER_DD,
  INIT_COMPANY_MARKUP,
  ADD_CUSTOMERMARKUP_RECORD,
} from "../../../constants/action-types/customersMarkup";

const tranformToCustomerMarkupGridView = (customerMarkupData) => {
  return {
    customerMarkupListView: { columns: [], rows: customerMarkupData },
  };
};

const INITIAL_STATE = {
  customerMarkupListView: [],
  isLoading: false,
  isEditCustomerMarkupSuccess: false,
  isEditCustomerMarkupCardError: false,
  isCreateCustomerMarkupSuccess: false,
  isCreateCustomerMarkupError: false,
  error: null,
  customerMarkup: [],
  fuelCompanyProviderDD: {},
  fuelCustomerCompanynNameProviderDD: {},
};

export const customerMarkupReducer = (state = INITIAL_STATE, action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case INIT_COMPANY_MARKUP:
      return { ...INIT_COMPANY_MARKUP, isLoadingPage: true };
    case EDIT_CUSTOMERMARKUP_RECORD.START:
    case FUEL_COMPANY_PROVIDER_DD.START:
    case FUEL_CUSTOMER_COMPANY_NAME_PROVIDER_DD.START:
    case ADD_CUSTOMERMARKUP_RECORD.START:
    case FETCH_CUSTOMERMARKUP_LIST_START:
      return { ...state, isLoading: true };

    case FETCH_CUSTOMERMARKUP_LIST_SUCCESS: {
      const { page } = action.payload;
      const { content } = action.payload;
      let resetState = {
        customerMarkupListView: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        isCreateCustomerMarkupSuccess: false,
        isCreateCustomerMarkupError: false,
        customerMarkup: content,
      };

      if (!content) {
        return resetState;
      }

      const { number, size, total_elements, total_pages } = page;
      return {
        ...resetState,
        customerMarkupListView: content,
        paginationInfo: {
          pageSize: size,
          totalRecords: total_elements,
          totalPages: total_pages,
          pageNumber: number,
        },
      };
    }

    case FETCH_CUSTOMERMARKUP_LIST_ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        customerMarkupListView: [],
        customerMarkup: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
        isAccidentDeletionSuccess: false,
        isAccidentDeletionError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }

    case EDIT_CUSTOMERMARKUP_RECORD.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isEditCustomerMarkupSuccess: false,
        isEditCustomerMarkupCardError: true,
      };
    }

    case EDIT_CUSTOMERMARKUP_RECORD.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isEditCustomerMarkupSuccess: true,
        isEditCustomerMarkupCardError: false,
      };
    }

    case ADD_CUSTOMERMARKUP_RECORD.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        isCreateCustomerMarkupSuccess: false,
        isCreateCustomerMarkupError: true,
        error,
      };
    }

    case ADD_CUSTOMERMARKUP_RECORD.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isCreateCustomerMarkupSuccess: true,
        isCreateCustomerMarkupError: false,
      };
    }

    case FUEL_COMPANY_PROVIDER_DD.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
      };
    }

    case FUEL_COMPANY_PROVIDER_DD.SUCCESS: {
      const { content } = action.payload;
      return {
        ...state,
        isLoading: false,
        fuelCompanyProviderDD: content,
      };
    }

    case FUEL_CUSTOMER_COMPANY_NAME_PROVIDER_DD.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
      };
    }
    case FUEL_CUSTOMER_COMPANY_NAME_PROVIDER_DD.SUCCESS: {
      const { content } = action.payload;
      return {
        ...state,
        isLoading: false,
        fuelCustomerCompanynNameProviderDD: content,
      };
    }


    default:
      return state;
  }
};
